import { render, staticRenderFns } from "./carouselItem.vue?vue&type=template&id=43eb668a&scoped=true&"
import script from "./carouselItem.vue?vue&type=script&lang=js&"
export * from "./carouselItem.vue?vue&type=script&lang=js&"
import style0 from "./carouselItem.vue?vue&type=style&index=0&id=43eb668a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eb668a",
  null
  
)

export default component.exports